// OutputOptions.tsx
import { BarChart2, Wand2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export type OutputMode = 'audit' | 'full'

interface OutputOptionsProps {
  value: OutputMode
  onChange: (mode: OutputMode) => void
}

const OPTIONS: Array<{ id: OutputMode; Icon: React.ComponentType<{ className?: string }> }> = [
  { id: 'audit', Icon: BarChart2 },
  { id: 'full',  Icon: Wand2 },
]

export function OutputOptions({ value, onChange }: OutputOptionsProps) {
  const { t } = useTranslation()
  return (
    <div className="campaign-creator-output grid grid-cols-2 gap-2.5" role="radiogroup"
         aria-label={t('campaignCreator.outputLabel')}>
      {OPTIONS.map(({ id, Icon }) => (
        <button
          key={id}
          role="radio"
          aria-checked={value === id}
          onClick={() => onChange(id)}
          className={[
            'campaign-creator-output-card flex items-start gap-3 rounded-[14px] border-2 p-3.5 text-left transition-all',
            value === id
              ? 'border-primary-500 bg-primary-500/10'
              : 'border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 hover:border-neutral-300 dark:hover:border-neutral-600',
          ].join(' ')}
        >
          <div className={[
            'flex h-9 w-9 shrink-0 items-center justify-center rounded-[9px]',
            value === id
              ? id === 'full' ? 'bg-primary-500/15 text-primary-500' : 'bg-primary-500/15 text-primary-500'
              : 'bg-neutral-200 dark:bg-neutral-700 text-neutral-500',
          ].join(' ')}>
            <Icon className="h-4 w-4" aria-hidden="true" />
          </div>
          <div>
            <div className="text-sm font-bold text-neutral-900 dark:text-white mb-0.5">
              {t(`campaignCreator.output.${id}.name`)}
            </div>
            <div className="text-2xs text-neutral-500 dark:text-neutral-400 leading-relaxed">
              {t(`campaignCreator.output.${id}.desc`)}
            </div>
          </div>
        </button>
      ))}
    </div>
  )
}
